import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useMemo } from 'preact/hooks';
const PlanGroupInputRadio = ({ value, planGroup, onInput }) => {
    const handleInput = () => {
        onInput(planGroup);
    };
    const checked = useMemo(() => {
        return planGroup.id === value;
    }, [planGroup.id, value]);
    return (_jsxs("label", Object.assign({ class: "radio" }, { children: [_jsx("input", { type: "radio", name: "group", class: "mr1", onInput: handleInput, checked: checked }, void 0), planGroup?.groupName ?? '名称無し'] }), void 0));
};
export default PlanGroupInputRadio;
